import React from 'react';
import { useSelector } from 'react-redux';

export default function usePolicySelector() {
  const PolicyListData = useSelector((state) => state.Policy.list_data?.policies) || []; // List data
  const PolicyViewData = useSelector((state) => state.Policy.view_data) || {}; // View
  const PolicyEdit = useSelector((state) => state.Policy.edit_data) || {}; // edit

  return { PolicyListData, PolicyViewData, PolicyEdit };
}
